import PropTypes from 'prop-types';

export const CurrencyConversionRatePropTypes = PropTypes.shape({
  endSpotRate: PropTypes.number.isRequired,
  fromCurrencyPrecision: PropTypes.number.isRequired,
  monthlyOperatingRate: PropTypes.number.isRequired,
  openSpotRate: PropTypes.number.isRequired,
  toCurrencyPrecision: PropTypes.number.isRequired,
  weightedAverageRate: PropTypes.number.isRequired,
  fromCurrency: PropTypes.string.isRequired,
  periodName: PropTypes.string.isRequired,
  toCurrency: PropTypes.string.isRequired,
});

export const CurrencyConversionRatesPropTypes = PropTypes.arrayOf(CurrencyConversionRatePropTypes);

const ExtendedFieldPropTypes = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isUpdated: PropTypes.bool.isRequired,
});

export const ExtendedCurrencyConversionRatesPropTypes = PropTypes.arrayOf(PropTypes.shape({
  isUpdated: PropTypes.string,
  endSpotRate: ExtendedFieldPropTypes.isRequired,
  fromCurrencyPrecision: ExtendedFieldPropTypes.isRequired,
  monthlyOperatingRate: ExtendedFieldPropTypes.isRequired,
  openSpotRate: ExtendedFieldPropTypes.isRequired,
  toCurrencyPrecision: ExtendedFieldPropTypes.isRequired,
  weightedAverageRate: ExtendedFieldPropTypes.isRequired,
  fromCurrency: ExtendedFieldPropTypes.isRequired,
  periodName: ExtendedFieldPropTypes.isRequired,
  toCurrency: ExtendedFieldPropTypes.isRequired,
  validationData: PropTypes.shape({
    value: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  }),
}));

export const ImportStatsPropTypes = PropTypes.shape({
  loaded: PropTypes.number,
  errors: PropTypes.number,
  adds: PropTypes.number,
  updates: PropTypes.number,
}).isRequired;
